import { render, staticRenderFns } from "./Cloundbtn.vue?vue&type=template&id=040a50f6&scoped=true&"
import script from "./Cloundbtn.vue?vue&type=script&lang=ts&"
export * from "./Cloundbtn.vue?vue&type=script&lang=ts&"
import style0 from "./Cloundbtn.vue?vue&type=style&index=0&id=040a50f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040a50f6",
  null
  
)

export default component.exports